"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleShipmentType = void 0;
exports.WholesaleShipmentType = {
    PartialPallet: "PARTIAL_PALLET",
    Parcel: "PARCEL",
};
//# sourceMappingURL=wholesale-shipment-type.js.map